// @flow

import { SHA256 } from 'crypto-js';

const getSessionStorageKey = (pathname: string) =>
  pathname && typeof pathname === 'string'
    ? `session-resume:${SHA256(pathname).toString()}`
    : '';

export default getSessionStorageKey;
